"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ExploreEditor;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function ExploreEditor(props) {
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 9L11 8H31L31.7071 8.29289L37.7071 14.2929L38 15V24H36V16H31L30 15V10H12V38H23V40H11L10 39V9ZM32 11.4142L34.5858 14H32V11.4142Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.2426 29.7574C35.8995 27.4142 32.1005 27.4142 29.7574 29.7574C27.4142 32.1005 27.4142 35.8995 29.7574 38.2426C31.8596 40.3449 35.1337 40.561 37.4769 38.891L42.2929 43.707L43.7071 42.2928L38.8911 37.4768C40.561 35.1336 40.3449 31.8596 38.2426 29.7574ZM31.1716 31.1716C32.7337 29.6095 35.2663 29.6095 36.8284 31.1716C38.3905 32.7337 38.3905 35.2663 36.8284 36.8284C35.2663 38.3905 32.7337 38.3905 31.1716 36.8284C29.6095 35.2663 29.6095 32.7337 31.1716 31.1716Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M16 22H32V24H16V22Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M16 26H28V28H16V26Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M16 30H24V32H16V30Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 14H24V20H16V14ZM18 16V18H22V16H18Z"
    }));
}

//# sourceMappingURL=ExploreEditor.js.map